<template>
    <div @mouseleave="displayMenuSwitcher = false" >

        <ul class="language-switcher" :class="{'displayMenuSwitcherContainer' : displayMenuSwitcher}" v-if="!$page.props.force_english">
            <li v-for="(url,lang_key) in $page.props.translated_routes">
                <p v-if="current_language === lang_key" @click="displayMenuSwitcher = !displayMenuSwitcher"
                   class="currentLanguage" :class="{'isActive' : displayMenuSwitcher}" :key="lang_key">{{ lang_key }} </p>
            </li>
            <div     :class="displayMenuSwitcher ? 'displayMenuSwitcher' : 'menuSwitcher'">
                <li v-for="(url,lang_key) in $page.props.translated_routes">
                    <a v-if="current_language !== lang_key" class="otherLanguage" :href="url">{{ lang_key }}</a>
                </li>
            </div>
        </ul>

        <ul class="language-switcher" :class="{'displayMenuSwitcherContainer' : displayMenuSwitcher}" v-if="$page.props.force_english">
            <li v-for="(url,lang_key) in $page.props.translated_routes">
                <p v-if="current_language === lang_key" @click="displayMenuSwitcher = !displayMenuSwitcher"
                   class="currentLanguage" :class="{'isActive' : displayMenuSwitcher}" :key="lang_key">{{ lang_key }} </p>
            </li>
            <div     :class="displayMenuSwitcher ? 'displayMenuSwitcher' : 'menuSwitcher'">
                <li >
                </li>
            </div>
        </ul>
    </div>
    <!--    <select class="language-switcher" onchange="location = this.value;">-->
    <!--        <option v-for="(url,lang_key) in $page.props.translated_routes" :key="lang_key" :value="url">{{lang_key}}</option>-->
    <!--    </select>-->
</template>


<script>
import {Link} from "@inertiajs/inertia-vue3";

export default {
    components: {
        Link
    },
    data() {
        return {
            current_language: this.$page.props.current_locale,
            display_language: true,
            displayMenuSwitcher: false,


        }
    },
    methods: {},
}
</script>

<style scoped>

</style>
